import React, { useState, useEffect } from 'react';
import Drawer from '@material-ui/core/Drawer';
import { SideBarDialogTitle, SideBarDialogContent, SideBarDialogActions } from '../Dialog/Dialog';
import { connect } from 'react-redux';
import { withRouter, useHistory, useLocation } from 'react-router-dom';
import { numberFormat, numberWithCommas, validNumberCheck, replaceCommas, findArrayObject, findArrayObjectIndex, getMilliDatePickerDateInStringDDMMMYYYY } from '../../../utils/utils';
import * as logger from '../../../logger';
import {
    TextField,
    Radios,
    Select,
    DatePicker,
    TimePicker,
    Autocomplete,
    Switches,
    Checkboxes
} from 'mui-rff';
import { Form } from 'react-final-form';
import { YourDetailsSideBarCss } from './InvoiceSideBarCss';
import TextInputState from '../Inputs/TextInputState';
import SyncIcon from '@material-ui/icons/Sync';
import {
    Grid,
    IconButton,
    Button,
    withStyles
} from '@material-ui/core';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import { GetValuesFromGst, updateChatView } from "../../../store/actions/userActionCreators";
import { getAllLocationsForProfile, getAllLocationsForGST,getAllLocationsForStates } from '../../../store/actions/homeActionCreator';
import { editPartyDetailsInvoice } from '../../../store/actions/partiesActionCreator';
import { trackDwebEvent } from '../../analytics';
import { editInvoice } from '../../../store/actions/tripActionCreator';


const filter = createFilterOptions({
    limit: 30
});

const BlueCheckbox = withStyles({
    root: {
        color: '#c7c7c7',
        '&$checked': {
            color: '#0033cc',
        },
    },
    checked: {},
})((props) => <Checkboxes color="default" {...props} />);

const GSTDetailsSideBar = ({
    open,
    onClose,
    onConfirm,
    trip,
    user,
    sideBarName,
    dispatchGetDetailsFromGst,
    dispatchGetAllLocationsForProfile,
    dispatchChatView,
    dispatchEditInvoice,
    dispatchGetAllLocationsForGST
}) => {

    let submit;

    const [dialogOpen, setDialogOpen] = useState(open);
    const [confirmDisabled, setConfirmDisabled] = useState(false);
    const [addGSTValue, setAddGSTValue] = useState(false);
    const [gstPercentage, setGSTPercentage] = useState("");
    const [gstType, setGSTType] = useState("");
    const [gstStates, setGSTStates] = useState([]);
    const [stateTIN, setStateTIN] = useState("");
    const [hsnCode, setHsnCode] = useState("");
    const [spinMotion, setSpinMotion] = useState(false);
    const [companyNameValue, setCompanyNameValue] = useState("");
    const [addressLine1Value, setAddressLine1Value] = useState("");
    const [addressLine2Value, setAddressLine2Value] = useState("");
    const [stateValue, setStateValue] = useState("");
    const [pincodeValue, setPincodeValue] = useState("");
    const [emailAddressValue, setEmailAddressValue] = useState("");
    const [mobileNumberValue, setMobileNumberValue] = useState("");
    const [displayFillGstInfo, setDisplayFillGstInfo] = useState(true);
    const [invoiceIdValue, setInvoiceIdValue] = useState("");
    const [placeInputValue,setPlaceInputValue] = useState("");

    const classes = YourDetailsSideBarCss();

    const initialValues = {
        addGST: addGSTValue,
        gstPercentage: gstPercentage,
        gstType: gstType,
        stateTIN: stateTIN,
        hsnCode: hsnCode
    }

    useEffect(() => {

        dispatchChatView(false);

        dispatchGetAllLocationsForGST(
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    setGSTStates(data.response);
                    if (trip && trip.singleInvoiceInfo) {
                        const gstInfo = trip.singleInvoiceInfo.gstInfo;
                        if (gstInfo && gstInfo.stateTIN) {
                            let state = findArrayObject('TIN', gstInfo.stateTIN, data.response)
                            setStateTIN(state);
                        }
                    }
                }
                logger.log("Your Details Side Bar Dweb", "------> Get all locations Success ");
            }, () => {
                logger.log("Your Details Side Bar Dweb", "------> Get all locations Failure");
            });

    }, [open]);

    useEffect(() => {

        if (trip && trip.singleInvoiceInfo) {
            const gstInfo = trip.singleInvoiceInfo.gstInfo;
            setInvoiceIdValue(trip.singleInvoiceInfo.invoiceDetails && trip.singleInvoiceInfo.invoiceDetails.id ? trip.singleInvoiceInfo.invoiceDetails.id : "");
            if (gstInfo && gstInfo.addGST) {
                setAddGSTValue(gstInfo.addGST);
                setHsnCode(gstInfo.hsnCode);
                setGSTPercentage({
                    title: gstInfo.gstPercentage + "%",
                    value: gstInfo.gstPercentage
                })
                setGSTType({
                    title: gstInfo.gstType,
                    value: gstInfo.gstType
                })
                if (gstInfo && gstInfo.stateTIN) {
                    let state = findArrayObject('TIN', gstInfo.stateTIN, gstStates)
                    setStateTIN(state);
                }
            }

        }

    }, [trip.singleInvoiceInfo]);

    const onSubmit = async values => {
        const gstData = {
            gstInfo: {
                addGST: values && values.addGST ? true : false,
                hsnCode: hsnCode,
                gstPercentage: values && values.gstPercentage && values.gstPercentage.value ? values.gstPercentage.value : -1,
                gstType: values && values.gstType && values.gstType.value ? values.gstType.value : -1,
                stateTIN: values && values.stateTIN && values.stateTIN.TIN ? values.stateTIN.TIN : -1,
            }
        }

        dispatchEditInvoice(invoiceIdValue,
            gstData,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log('Party Details Side Bar Dweb', 'Edit Party Details Successfull');
                    setDialogOpen(false);
                    onConfirm();
                    if (data.response) {
                        const invoiceInfo = trip && trip.singleInvoiceInfo ? trip.singleInvoiceInfo : {};
                    }
                }
            },
            () => {
                logger.log('Party Details Side Bar Dweb', 'Edit Party Details Failed');
            }
        )

    }

    const validate = values => {

        const errors = {};
        /*if (!values.addGST) {
            errors.addGST = "Please select above checkbox to enter GST."
        }*/
        if (!values.gstPercentage && values.addGST) {
            errors.gstPercentage = "Please select GST Percentage"
        }
        if (!values.gstType && values.addGST) {
            errors.gstType = "Please select GST Type"
        }
        if (!values.stateTIN && values.addGST) {
            errors.stateTIN = "Please select State"
        }
        if (errors && Object.keys(errors).length !== 0 && errors.constructor === Object) {
            setConfirmDisabled(true);
        } else {
            setConfirmDisabled(false);
        }

        return errors;
    }

    const getFormFields = (values) => {
        return [
            {
                size: 12,
                visible: true,
                inline: false,
                field: (<BlueCheckbox
                    size='small'
                    margin='normal'
                    fullWidth={true}
                    formControlProps={{
                        className: classes.switchControl
                    }}
                    onChange={(e, value) => {
                        setAddGSTValue(value)
                        if(!value){
                            setGSTPercentage("");
                            setGSTType("");
                            setStateTIN("");
                            setHsnCode("")
                        }
                    }}
                    formGroupProps={{}}
                    formControlLabelProps={{
                        classes: {
                            label: classes.switchLabel
                        },
                        labelPlacement: 'end',
                    }}
                    name="addGST"
                    data={{ label: 'Add GST under Reverse Charge (RCM)', value: true }} label="" />)
            },
            {
                size: 12,
                visible: true,
                inline: false,
                field: (
                    <div className={classes.mtV1}>
                        <div className={classes.titleV1}>GST Percentage*</div>
                        <Autocomplete
                            id="select-gst-per-list"
                            name="gstPercentage"
                            size="small"
                            //value={stateValue}
                            fullWidth
                            disabled={!values.addGST}
                            placeholder="GST Percentage"
                            onChange={(event, newValue) => {
                                setGSTPercentage(newValue)
                            }}
                            options={[
                                { title: '5%', value: 5 },
                                { title: '12%', value: 12 },
                                { title: '18%', value: 18 },
                                { title: '28%', value: 28 }
                            ]}
                            getOptionLabel={(option) => {
                                return option.title ? option.title : '';
                            }}
                            renderOption={(option, params) => {
                                return (
                                    <div className={classes.divV1Gst}>
                                        <div className={classes.divV2Gst}>
                                            {option.title}
                                        </div>
                                    </div>
                                );
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    // label="Enter Reason"
                                    placeholder="GST Percentage"
                                    variant="outlined"
                                    fullWidth
                                    name="gstPercentage"
                                    style={{ margin: 0, marginTop: 4 }}
                                />
                            )}
                            multiple={false}
                            classes={{
                                root: classes.autocompleteRootGst,
                                listbox: classes.autoCompleteListbox,
                                option: classes.autoCompleteOption
                            }}
                        />
                    </div>
                )
            },
            {
                size: 12,
                visible: true,
                inline: false,
                field: (
                    <div className={classes.mtV1}>
                        <div className={classes.titleV1}>GST Type*</div>
                        <Autocomplete
                            id="select-gst-type-list"
                            name="gstType"
                            size="small"
                            //value={stateValue}
                            fullWidth
                            disabled={!values.addGST}
                            placeholder="GST Type"
                            onChange={(event, newValue) => {
                                setGSTType(newValue)
                            }}
                            options={[
                                { title: 'IGST', value: 'IGST' },
                                { title: 'CGST + SGST', value: 'CGST + SGST' }
                            ]}
                            getOptionLabel={(option) => {
                                return option.title ? option.title : '';
                            }}
                            renderOption={(option, params) => {
                                return (
                                    <div className={classes.divV1Gst}>
                                        <div className={classes.divV2Gst}>
                                            {option.title}
                                        </div>
                                    </div>
                                );
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    // label="Enter Reason"
                                    placeholder="GST Type"
                                    variant="outlined"
                                    fullWidth
                                    name="gstType"
                                    style={{ margin: 0, marginTop: 4 }}
                                />
                            )}
                            classes={{
                                root: classes.autocompleteRootGst,
                                listbox: classes.autoCompleteListbox,
                                option: classes.autoCompleteOption
                            }}
                            multiple={false}
                        />
                    </div>
                )
            },
            {
                size: 12,
                visible: true,
                inline: false,
                field: (
                    <div className={classes.mtV1}>
                        <div className={classes.titleV1}>Place of Supply*</div>
                        <Autocomplete
                            id="select-gst-states-list"
                            name="stateTIN"
                            size="small"
                            //value={stateValue}
                            fullWidth
                            disabled={!values.addGST}
                            placeholder="Place of Supply"
                            onChange={(event, newValue) => {
                                setStateTIN(newValue)
                            }}
                            options={gstStates}
                            getOptionLabel={(option) => {
                                return option.State ? option.State : '';
                            }}
                            renderOption={(option, params) => {
                                return (
                                    <div className={classes.divV1Gst}>
                                        <LocationOnIcon className={classes.colorV1} />
                                        <div className={classes.divV2Gst}>
                                            {option.State}
                                        </div>
                                    </div>
                                );
                            }}
                            textFieldProps={
                                {
                                  placeholder: "Place of Supply",
                                  variant: "outlined",
                                  fullWidth:true
                                }
                            }
                            /*inputValue={placeInputValue}
                            onInputChange={(e, val) => {
                                setPlaceInputValue(val)
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    // label="Enter Reason"
                                    placeholder="Place of Supply"
                                    variant="outlined"
                                    //fullWidth
                                    //name="stateTIN"
                                    //style={{ margin: 0, marginTop: 4 }}
                                />
                            )}*/
                            classes={{
                                root: classes.autocompleteRootGst,
                                listbox: classes.autoCompleteListbox,
                                option: classes.autoCompleteOption
                            }}
                            multiple={false}
                        />
                    </div>
                )
            },
            {
                size: 12,
                visible: true,
                inline: false,
                field: (
                    <div className={classes.mtV1}>
                        <div className={classes.titleV1}>HSN Code</div>
                        <TextInputState
                            placeholder="HSN Code"
                            name="hsnCode"
                            disabled={!values.addGST}
                            variant="outlined"
                            size="small"
                            onChange={(e) => { setHsnCode(e.target.value) }}
                            className={classes.mtV2}
                            classes={{ root: classes.textFieldV1 }}
                        />
                    </div>
                )
            }
        ]
    }
    const handleClose = () => {
        setDialogOpen(false);
        onClose();
        dispatchChatView(true);
    }

    return (
        <>
            <Drawer
                variant="temporary"
                anchor="right"
                open={dialogOpen}
                ModalProps={{
                    keepMounted: false,
                    className: classes.modal,
                    BackdropProps: {
                        className: classes.backdrop
                    },
                    disableBackdropClick: true,
                    disableEscapeKeyDown: true,
                    //onBackdropClick: handleClose
                }}
                classes={{
                    paper: classes.transactionDetailsDrawer
                }}
            >
                <SideBarDialogTitle id={"right-sidebar-for-" + sideBarName ? sideBarName : ''} onClose={handleClose} className={classes.dialogTitle} >
                    <div className={classes.divTitle}>
                        GST Info
                    </div>
                </SideBarDialogTitle >

                <SideBarDialogContent dividers className={classes.sideBarDialogContentV1} >

                    <Form
                        onSubmit={onSubmit}
                        initialValues={initialValues}
                        validate={validate}
                        render={({ handleSubmit, form, submitting, pristine, values }) => {
                            submit = handleSubmit; return (
                                <form onSubmit={handleSubmit} noValidate>
                                    <Grid container alignItems="flex-start" spacing={0}>
                                        {getFormFields(values).map((item, idx) => item.visible ? (
                                            <Grid item xs={item.size} key={idx}>
                                                {item.field}
                                            </Grid>
                                        ) : null)}
                                    </Grid>
                                </form>
                            )
                        }}
                    />

                </SideBarDialogContent>

                <SideBarDialogActions className={classes.dialogActions} >

                    <Button variant="contained" className={classes.cancelButton} onClick={() => handleClose()}>
                        Cancel
                    </Button>
                    <Button variant="contained" className={classes.saveButton} classes={{ disabled: classes.saveButtonDisabled }} disabled={confirmDisabled}
                        onClick={event => submit(event)}
                    >
                        Save
                    </Button>

                </SideBarDialogActions>

            </Drawer>
        </>
    )
}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({

    dispatchGetDetailsFromGst: (gstNumber, onSuccess, onFailure) => { dispatch(GetValuesFromGst(gstNumber, onSuccess, onFailure)) },
    dispatchChatView: (value) => dispatch(updateChatView(value)),
    dispatchGetAllLocationsForProfile: (onSuccess, onFailure) => { dispatch(getAllLocationsForStates(onSuccess, onFailure)) },
    dispatchGetAllLocationsForGST: (onSuccess, onFailure) => { dispatch(getAllLocationsForGST(onSuccess, onFailure)) },
    dispatchEditInvoice: (invoiceId, invoiceData, onSuccess, onFailure) => {
        dispatch(editInvoice(invoiceId, invoiceData, onSuccess, onFailure))
    },

});

export default connect(mapStateToProps, mapDispatchToProps)(GSTDetailsSideBar);
